<template>
<div class="info-question">
  <div>
    <img v-if="node.question.image !== null" :src="node.question.image" class="question-image" />
    <p v-if="node.prompt !== null" v-html="node.prompt"></p>
    <div v-html="node.question.instructions"></div>
    <div class="cta" v-if="hasCTA">
      <v-btn
        class="cta-button"
        color="success"
        @click="onCTA">
        {{ node.question.call_to_action }}
      </v-btn>
    </div>
  </div>
  <div class="buttons" v-if="!isExit">
    <v-btn
      class="submit-button"
      color="primary"
      @click="onAnswerQuestion">
      {{ continueButton }}
    </v-btn>
  </div>
</div>
</template>

<script>
export default {
  name: 'Information',
  computed: {
    isExit() {
      return (this.node.links.length === 1 && this.node.links[0].target === null);
    },
    hasCTA() {
      return this.node.question.call_to_action_url !== null
        && this.node.question.call_to_action != null
        && this.node.question.call_to_action_url.length > 0
        && this.node.question.call_to_action.length > 0;
    },
  },
  methods: {
    onAnswerQuestion() {
      this.$emit('answer', { id: null, node: this.node });
    },
    onCTA() {
      window.open(this.node.question.call_to_action_url);
    },
  },
  props: {
    node: Object,
    continueButton: String,
  },
  mounted() {
    if (this.isExit) {
      this.$emit('complete');
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.info-question {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;
  margin-bottom: 2rem;

  .question-image {
    display: block;
    max-width: 340px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
  }

  .cta {
    display: flex;
    justify-content: center;
  }

  .buttons {
    display: flex;
    width: 100%;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-self: center;
  }
}

@media (min-width: $breakpoint-tablet) {
  .info-question {
    justify-content: flex-start;

    .buttons {
      margin-top: 3rem;
    }
  }
}
</style>
